import React, { useRef } from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconActivityLog, IconOrganization } from '../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../shared/audit/use-audit-capabilities'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuExport, MenuItem, MenuRecycle, MenuTableSettingToggle } from '../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { OrganizationGrid } from '../../../../../shared/org-search/organization-grid'
import { exportOrganizations } from '../../../../../shared/org-search/org-export'
import { useNotificationContext } from '../../../../../context/notification/context'
import { withReference } from '../../../../../shared/error/error-notice'
import { serverMessage } from '../../../../../shared/sso-workspace/format'
import { useRoleSysOrganization } from '../../../../../role/hook/role-sys'
import { ColumnMenu } from '../../../../../shared/table-builder/table-columns'

// Every organization, server-paged (owner 2026-10-13): content's search a
// page at a time, company organizations first; the search box finds one by
// name. Export is every organization, a CSV content builds.
export function OrganizationList() {
  const roleSysOrganization = useRoleSysOrganization()
  const caps = useAuditCapabilities()

  const tableRef = useRef()
  const notificationContext = useNotificationContext()
  const handleExportCsv = async () => {
    try {
      await exportOrganizations()
    } catch (err) {
      notificationContext.toast.notify(withReference(serverMessage(err, "The organization export couldn't be made."), err), 5000)
    }
  }
  const handleTableSettingToggle = () => tableRef.current.toggleSideBar()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add organization" to="/admin/organization/list/add" show={roleSysOrganization.accessCreate} />
      <MenuRecycle to="/admin/organization/list/recycle" show={roleSysOrganization.accessDelete} />

      <MenuExport onClick={handleExportCsv} show />
      <MenuTableSettingToggle onClick={handleTableSettingToggle} show />
      <MenuItem Icon={IconActivityLog} text="audit log" to="/admin/audit-log?type=organizations" show={caps.sysAuditLog} />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconOrganization} text="Organizations">
        <CardFullHeightScrollY title="organization" HeaderMenu={HeaderMenu}>
          <OrganizationGrid ref={tableRef}
            emptyState={{
              Icon: IconOrganization,
              title: 'No organizations yet',
              message: 'Organizations you add appear here.',
              action: { label: 'Add organization', to: '/admin/organization/list/add', show: roleSysOrganization.accessCreate }
            }}>
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`/admin/organization/list/edit/${row.id}`} show={roleSysOrganization.accessUpdate} />
                  <MenuDelete to={`/admin/organization/list/edit/${row.id}/delete`} show={roleSysOrganization.accessDelete} />
                </Menu>}
            />
          </OrganizationGrid>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
